import { IStudioLibraryItem } from "@app/shared/models/IStudioLibraryItem";
import { AssetType } from "@app/shared/models/assetType";

export class PricePointTemplate implements IStudioLibraryItem{
  id: number;
  uuid:string;
  name: string;
  type:AssetType;
  src?: string;
  fabricElem:any;
  targetField:string;
  svgSrc:string;
  jsonSrc:string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/pricepointTemplate.ts